export default __webpack_public_path__ + "static/web/media/OurBusinessCulture.869c58cd.jpg";